const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllDatconsumo() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/datconsumo`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getDatconsumoByID(postId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/datconsumo/${postId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllDatconsumoByTax(taxId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/datconsumo?tratamiento=${taxId}&per_page=99`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}